import { FileInput, Group, Stack, Text } from '@mantine/core';
import { IconPhoto } from '@tabler/icons-react';
import { useState } from 'react';
import useUploadAsset from '../../helpers/useUploadAsset';
import ErrorMessage from '../ErrorMessage';
import LogoOnBackground from './LogoOnBackground';

// SVG is refused by the asset upload on the server, so the picker only offers raster formats.
const ACCEPTED = ['image/png', 'image/jpeg', 'image/webp'];

// One logo, shown on the background it is meant for, with an upload that fills `onChange(url)`.
const LogoField = ({ label, description, background, value, onChange, help, provenance, error }) => {
  const [uploadError, setUploadError] = useState();
  const [uploading, setUploading] = useState(false);
  const { uploadReferenceImage } = useUploadAsset((err) => {
    setUploading(false);
    setUploadError(typeof err === 'string' ? err : err?.message);
  });

  const upload = (file) => {
    setUploadError(undefined);
    if (!file) {
      return;
    }
    if (!ACCEPTED.includes(file.type)) {
      setUploadError('Please use a PNG, JPG or WebP file.');
      return;
    }
    setUploading(true);
    uploadReferenceImage(
      { title: `${label} uploaded at ${new Date().toISOString()}`, description: label },
      file,
      (url) => {
        setUploading(false);
        onChange(url);
      }
    );
  };

  return (
    <Stack gap={6}>
      <Group gap={4}>
        <Text size="sm" fw={500}>
          {label}
        </Text>
        {help}
      </Group>
      <Text size="xs" c="dimmed">
        {description}
      </Text>
      <LogoOnBackground
        src={value}
        label={label}
        background={background}
        height={88}
        padding={12}
        imageHeight={60}
        failedText="We couldn't load this logo. Upload it again below."
      />
      {provenance}
      <FileInput
        aria-label={`Upload ${label.toLowerCase()}`}
        accept={ACCEPTED.join(',')}
        placeholder={uploading ? 'Uploading…' : 'Upload a PNG, JPG or WebP'}
        leftSection={<IconPhoto size={16} />}
        onChange={upload}
        disabled={uploading}
        clearable={false}
        value={null}
      />
      <ErrorMessage message={uploadError || error} />
    </Stack>
  );
};

export default LogoField;
